import axios from "axios";
import { useEffect, useState } from "react";
import _ from 'lodash';
import DefaultLoader from "../../../components/loader/DefaultLoader";
import PitcherTable from '../../../components/table/PitcherTable';
import { flatObject } from "../../../utils/flat";
import {useCookies} from 'react-cookie';
import TableWrapper from '../../../components/table/TableWrapper';
import dateSetting from "../../../utils/dateSetting";

function TotalPitcherRecord({profile}) {
    const [cookies] = useCookies(['hiball_token']);
    let [loading, setLoading] = useState(false);
    let [seasonRecord, setSeasonRecord] = useState([]);
    let {playerId, birthdate} = profile;

    const ballObj = {
        FAST: '직구',
        SLIDER: '슬라',
        CURVE: '커브',
        CHANGE: '포크'
    }

    useEffect(() => {
        let dateObj = dateSetting();

        let pitcherRecord = axios({
            url : `${process.env.REACT_APP_API_URL}`,
            params: {
                recordType: 'digestPitchingRecord', recordName: 'selectSeasonRecord',
                pitcherIds: playerId,
                seasons: [dateObj['season']-2, dateObj['season']-1, dateObj['season']].toString(),
                groupingColumn: 'season',
                gameTypeCode: 4201,
                authToken:JSON.stringify(cookies['hiball_token'])
            }
        });

        let pitcherTrackmanRecord = axios({
            url : `${process.env.REACT_APP_API_URL}`,
            params: {
                recordType: 'digestPitchingRecord', recordName: 'selectTrackingRecord',
                pitcherIds: playerId,
                seasons: [dateObj['season']-2, dateObj['season']-1, dateObj['season']].toString(),
                gameTypeCode: 4201,
                authToken:JSON.stringify(cookies['hiball_token'])
            }
        })

        let pitcherPitchRecord = axios({
            url : `${process.env.REACT_APP_API_URL}`,
            params: {
                recordType: 'digestPitchingRecord',
                recordName: 'selectPitchBallCodeRecord',
                pitcherIds: playerId,
                seasons: [dateObj['season']-2, dateObj['season']-1, dateObj['season']].toString(),
                gameTypeCode: 4201,
                authToken:JSON.stringify(cookies['hiball_token'])
            }
        });

        Promise.all([pitcherRecord, pitcherTrackmanRecord, pitcherPitchRecord])
        .then((result) => {
            let totalData = _.map(result[0]['data']['result'], (item) => {
                let season = item['season'];
                let birthdateYear = birthdate && birthdate.split('/');
                let age = (season*1-birthdateYear[0]*1)-1;

                item['type'] = item['season']+"_"+item['pitcher']['pitcherId'];
                item['age'] = age;
                return flatObject(item);
            });

            let trackmanData = _.map(result[1]['data']['result'], (item) => {
                item['type'] = item['season']+"_"+item['pitcherId'];
                return flatObject(item);
            });

            let pitchData = [];
            _.forEach(result[2]['data']['result'], (item, idx) => {
                item['type'] = item['season']+"_"+item['playerId']+"_"+idx;
                item['balltype'] = item['ballCode'];
                item['ballName'] = ballObj[item['ballCode']];
                let newPitchData = flatObject(item);

                if(newPitchData['ab']) {
                    pitchData.push(newPitchData);
                }
            });

            pitchData.sort((a,b) => a['season'] - b['season']);

            setSeasonRecord({
                totalData, trackmanData, pitchData
            });
            setLoading(true);
        })
    }, []);

    if(!loading) {
        return <div style={{height: '300px'}}><DefaultLoader /></div>
    }

    return (
        <>
        <TableWrapper title={'overall'} trackmanYn={true}>
            <PitcherTable data={seasonRecord['totalData']} column={'total'}/>
        </TableWrapper>
        <TableWrapper title={'pitchQuality'}>
            <PitcherTable data={seasonRecord['trackmanData']} column={'pitchingQuality'}/>
        </TableWrapper>
        <TableWrapper title={'battedBalls'}>
            <PitcherTable data={seasonRecord['trackmanData']} column={'hittingType'}/>
        </TableWrapper>
        <TableWrapper title={'pitchTypeInfo'}>
            <PitcherTable data={seasonRecord['pitchData']} column={'pitchData'}/>
        </TableWrapper>
        </>
    )
}

export default TotalPitcherRecord;